module.exports = __webpack_public_path__ + "static/media/fly0290.0966aa57.webp";